import React from "react";
import { AgoraVideoPlayer, ICameraVideoTrack, ILocalVideoTrack, IRemoteVideoTrack } from "agora-rtc-react";
import Avatar from "@components/profile/avatar";

interface ICurrentUserVideoProps
{
    showVideo: boolean,
    videoTrack: ILocalVideoTrack | IRemoteVideoTrack | ICameraVideoTrack,
    username: string,
    size: number
}

const CurrentUserVideo = (props: ICurrentUserVideoProps) => {
    const { showVideo, videoTrack, username, size } = props;
    return (
        <>
            {
                showVideo ?
                <AgoraVideoPlayer
                    className=""
                    videoTrack={videoTrack}
                    style={{ borderRadius: '0px', width: '100%', height: '100%' }}
                />
                :
                <div className="VideoCall__Avatar">
                    <Avatar
                        username={username}
                        roleCode="PR"
                        size={size}
                        editable={false}
                    />
                </div>
            }
        </>
    )
}

export default CurrentUserVideo;
